import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  IonList,
  IonGrid,
  IonRow,
  IonListHeader,
  IonSkeletonText,
} from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wilson-working-time-section-wrapper',
  standalone: true,
  templateUrl: './section-wrapper.component.html',
  styleUrls: ['./section-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonList,
    IonGrid,
    IonRow,
    IonListHeader,
    IonSkeletonText,
    TranslatePipe,
  ],
})
export class SectionWrapperComponent {
  readonly isLoading = input<boolean>(false);
  readonly title = input.required<string>();
  readonly shouldHide = input<boolean>(false);
}
